<kendo-card width="100%" class="profile-card">
  <kendo-card-header class="k-hstack">
    <div class="row">
      <div class="col-12 col-lg-12">
        <hyperkit-typography
          variant="emphasized"
          size="sm"
          align="left"
          color="inactive"
          >Threat Profile</hyperkit-typography
        >
      </div>
      <div class="col-12 col-lg-12">
        <threat-header>
          <header-title>
            <hyperkit-link
              routerLink="/research/threat-profile/{{ data.UUID }}"
              variant="h5"
              color="primary"
              [text]="data.title"
            >
            </hyperkit-link>
          </header-title>
          <header-options>
            @if (favorited) {
              <i
                class="k-icon k-font-icon k-i-bookmark-outline favorite"
                (click)="unfavorite()"
              ></i>
            }
            @if (!favorited) {
              <i
                class="k-icon k-font-icon k-i-bookmark favorite"
                (click)="favorite()"
              ></i>
            }
          </header-options>
        </threat-header>
        <div class="profile-content">
          <profile-description>
            <hyperkit-typography
              variant="body"
              size="md"
              align="left"
              color="body"
            >
              {{ data.overview }}</hyperkit-typography
            >
            <div class="meta">
              @if (data?.also_known_as.length > 0) {
                <div>
                  <hyperkit-badge
                    variant="neutral"
                    text="Also Known As"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    display="inline"
                    variant="emphasized"
                    size="sm"
                    align="left"
                    color="primary"
                    >{{ data?.also_known_as.join(', ') }}</hyperkit-typography
                  >
                </div>
              }
              <div>
                <hyperkit-badge
                  variant="neutral"
                  text="Impact"
                ></hyperkit-badge>
                <hyperkit-typography
                  display="inline"
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="primary"
                  >{{ data?.impact }}</hyperkit-typography
                >
              </div>
              <div>
                <hyperkit-badge
                  variant="neutral"
                  text="Threat Category"
                ></hyperkit-badge>
                <hyperkit-typography
                  display="inline"
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="primary"
                  >{{ data?.context?.threat_categories }}</hyperkit-typography
                >
              </div>
              <div>
                <hyperkit-badge
                  variant="neutral"
                  text="Motivation"
                ></hyperkit-badge>
                <hyperkit-typography
                  display="inline"
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="primary"
                  >{{ data?.context?.motivations }}</hyperkit-typography
                >
              </div>
            </div>
            <cyborg-facet-buttons
              [closable]="false"
              class="tile-facets"
              [facets]="tags"
              [groupByCategory]="false"
            ></cyborg-facet-buttons>
          </profile-description>
        </div>
      </div>
    </div>
  </kendo-card-header>
</kendo-card>
